import React from "react";
import {
  Box,
  Container,
  Grid,
  Typography,
  Stack,
  IconButton,
  Divider,
} from "@mui/material";
import ScienceIcon from "@mui/icons-material/Science";
import GitHubIcon from "@mui/icons-material/GitHub";
import LanguageIcon from "@mui/icons-material/Language";
import ArticleIcon from "@mui/icons-material/Article";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import EmailIcon from "@mui/icons-material/Email";

function Footer() {
  return (
    <Box
      component="footer"
      sx={{
        background:
          "linear-gradient(135deg, #1e3a8a 0%, #294696 50%, #3b82f6 100%)",
        color: "#ffffff",
        position: "relative",
        overflow: "hidden",
        pt: 10,
        pb: 5,
      }}
    >
      <Container maxWidth="lg">
        <Grid container spacing={6}>
          {/* BRAND */}
          <Grid item xs={12} md={4}>
            <Stack spacing={2}>
              <Stack direction="row" spacing={1} alignItems="center">
                <ScienceIcon sx={{ fontSize: 32 }} />
                <Typography variant="h6" fontWeight={900}>
                  Robio
                </Typography>
              </Stack>

              <Typography variant="body2" sx={{ opacity: 0.85, maxWidth: 320 }}>
                AI-assisted biological pathway & literature intelligence —
                translating PubMed evidence into actionable insights.
              </Typography>
            </Stack>
          </Grid>

          {/* PLATFORM */}
          <Grid item xs={6} md={2}>
            <Typography fontWeight={800} mb={1.5}>
              Platform
            </Typography>
            <Stack spacing={1}>
              {[
                "Analyze Compound",
                "Outcome Mapping",
                "Confidence Scoring",
              ].map((item) => (
                <Typography key={item} variant="body2" sx={{ opacity: 0.85 }}>
                  {item}
                </Typography>
              ))}
            </Stack>
          </Grid>

          {/* RESOURCES */}
          <Grid item xs={6} md={2}>
            <Typography fontWeight={800} mb={1.5}>
              Resources
            </Typography>
            <Stack spacing={1}>
              {["Documentation", "PubMed API", "Evidence Model"].map((item) => (
                <Typography key={item} variant="body2" sx={{ opacity: 0.85 }}>
                  {item}
                </Typography>
              ))}
            </Stack>
          </Grid>

          {/* CONNECT */}
          <Grid item xs={12} md={4}>
            <Typography fontWeight={800} mb={1.5}>
              Connect
            </Typography>

            <Stack direction="row" spacing={1.5}>
              {/* GitHub */}
              {/* <IconButton
                component="a"
                href="https://github.com/your-username"
                target="_blank"
                rel="noopener noreferrer"
                sx={iconStyle}
              >
                <GitHubIcon />
              </IconButton> */}

              {/* LinkedIn */}
              <IconButton
                component="a"
                href="https://www.linkedin.com/company/robio-ra"
                target="_blank"
                rel="noopener noreferrer"
                sx={iconStyle}
              >
                <LinkedInIcon />
              </IconButton>

              {/* Blog / Docs */}
              {/* <IconButton
                component="a"
                href="https://your-website.com"
                target="_blank"
                rel="noopener noreferrer"
                sx={iconStyle}
              >
                <ArticleIcon />
              </IconButton> */}

              {/* Email */}
              <IconButton
                component="a"
                href="papero.services@gmail.com"
                sx={iconStyle}
              >
                <EmailIcon />
              </IconButton>
            </Stack>
          </Grid>
        </Grid>

        <Divider sx={{ my: 4, bgcolor: "rgba(255,255,255,0.25)" }} />

        <Stack
          direction={{ xs: "column", sm: "row" }}
          justifyContent="space-between"
          alignItems="center"
          spacing={2}
        >
          <Typography variant="caption" sx={{ opacity: 0.85 }}>
            © {new Date().getFullYear()} Robio. All rights reserved.
          </Typography>

          <Typography variant="caption" sx={{ opacity: 0.85 }}>
            Built with ❤️ for science, research & discovery
          </Typography>
        </Stack>
      </Container>
    </Box>
  );
}

/* 🔥 Reusable Icon Style */
const iconStyle = {
  bgcolor: "rgba(255,255,255,0.15)",
  color: "#fff",
  transition: "all 0.25s ease",
  "&:hover": {
    bgcolor: "#fff",
    color: "#1e3a8a",
    transform: "scale(1.15)",
    boxShadow: "0 0 16px rgba(56,189,248,0.8)",
  },
};

export default Footer;
